
import { putChangeStudentForm, getStudentLastRequestComplete, getStudentDetail } from '../api.js'

// import pageApiData from '../utils/pageApiData.js'
import requestFormUtil from '../utils/requestFormUtil.js'
import notifications from '../notifications.js'

async function _setRequestFormValues(dbId) {
  let data = (await getStudentLastRequestComplete(dbId)).data

  if (data.schedule_request === null) {
    let studentDetail = (await getStudentDetail(data.student.db_id, { select: 'studentInfo' })).data
    data.schedule_request = requestFormUtil.remapStudentDetailToFormValues(studentDetail)
  }

  data = requestFormUtil.preprocessRequestFormValues(data)

  return data
}

function _putChangeStudentForm(content, dbId) {
  let promise = putChangeStudentForm(content, dbId)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  setRequestFormValues: _setRequestFormValues,
  putChangeStudentForm: _putChangeStudentForm,
}
